import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '@/design-system/atoms/Button';
import { Icon } from '@/design-system/atoms/Icons/Icon';
import Typography from '@/design-system/atoms/Typography';

import { Card } from '../Card';
import styles from './CardComplexContent.module.scss';

export const CardComplexContent = (props) => {
    const {
        className,
        isClickableCard = true,
        eyebrow,
        title,
        subtitle,
        featuredIcon = 'location-pin',
        featuredContent,
        body,
        cta,
        analyticsActionLabel,
        analyticsComponentTitle,
    } = props;

    return (
        <Card.Root isClickableCard={isClickableCard}>
            <Card.Container
                className={classNames(styles.card, className)}
                analyticsActionLabel={analyticsActionLabel}
                analyticsComponentTitle={analyticsComponentTitle}
            >
                <Card.Content className={styles['flex-content']}>
                    {eyebrow && (
                        <Typography
                            className={styles['eyebrow']}
                            variant="e1"
                            content={eyebrow}
                            lineClamp={1}
                        />
                    )}

                    {(title || subtitle) && (
                        <div className={styles['title-block']}>
                            {title && (
                                <Typography
                                    className={styles['title']}
                                    variant="t2b"
                                    content={title}
                                    lineClamp={3}
                                />
                            )}
                            {subtitle && (
                                <Typography
                                    className={styles['subtitle']}
                                    variant="t3"
                                    content={subtitle}
                                    lineClamp={1}
                                />
                            )}
                        </div>
                    )}

                    {featuredContent && (
                        <div className={styles['featured']}>
                            <Icon name={featuredIcon} className={styles['icon']} />
                            <Typography
                                className={styles['featured']}
                                variant="t3"
                                content={featuredContent}
                                lineClamp={1}
                                tag="span"
                            />
                        </div>
                    )}
                    {body && (
                        <Typography
                            className={styles['description']}
                            variant="t3"
                            content={body}
                            lineClamp={4}
                        />
                    )}
                </Card.Content>
                <div className={styles['spacer']} />
                {cta && (
                    <Card.CallToAction
                        {...cta}
                        analyticsActionLabel={analyticsActionLabel}
                        analyticsComponentTitle={analyticsComponentTitle}
                    />
                )}
            </Card.Container>
        </Card.Root>
    );
};

CardComplexContent.propTypes = {
    isClickableCard: PropTypes.bool,
    header: PropTypes.node,
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
    cta: PropTypes.shape(Button.propTypes),
    analyticsActionLabel: PropTypes.string,
    analyticsComponentTitle: PropTypes.string,
};
